/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncPrimaryStoredValueBalance} from '../api'

export const useMutationSyncPrimaryStoredValueBalance = createReactQueryMutationHook('syncPrimaryStoredValueBalance', syncPrimaryStoredValueBalance)
